import {
    IStation, IImomoResponse, IPrecipitationNorm, ITemperatureNorm
} from './api.types';

export interface IMeteostationApi {
  createStation(stationDetailsRequest:IStationDetailsRequest,
                historicalDataFilename:string[]):ng.IPromise<void>;
  getStations():ng.IPromise<IStation[]>;
  getStation(args:{stationCode?:string, stationId?:number}):ng.IPromise<IStation>;
  isStationCodeUnique(stationCode:string):ng.IPromise<void>;
  updateStation(stationId:number,
                stationUpdateDetailsRequest:IStationDetailsUpdateRequest):ng.IPromise<void>;

  getStationPrecipitationNorm(stationId:number):ng.IPromise<IPrecipitationNorm>;
  getStationHistoricPrecipitationDataUrl(stationId:number):ng.IPromise<string>;
  uploadHistoricPrecipitationData(stationId:number, filename:string):ng.IPromise<void>;
  validatePrecipitationData(filename:string):ng.IPromise<void>;

  getStationTemperatureNorm(stationId:number):ng.IPromise<ITemperatureNorm>;
  getStationHistoricTemperatureDataUrl(stationId:number):ng.IPromise<string>;
  uploadHistoricTemperatureData(stationId:number, filename:string):ng.IPromise<void>;
  validateTemperatureData(filename:string):ng.IPromise<void>;
}

export interface IStationDetailsRequest {
  basin:string,
  country:string,
  latitude:number,
  longitude:number,
  region:string,
  siteCode:string,
  siteName:string
}

export interface IStationDetailsUpdateRequest extends IStationDetailsRequest {
  id:number;
}

export default class MeteostationApi implements IMeteostationApi {
  static $inject = ['$http', '$q', 'backendUrl'];

  private endpoint:string;

  constructor(private $http:ng.IHttpService,
              private $q:ng.IQService, private backendUrl:string) {
    this.endpoint = `${this.backendUrl}/sites`;
  }

  createStation(stationDetailsRequest:IStationDetailsRequest,
                historicalDataFilename:string[]):angular.IPromise<void> {
    return this.$http({
      url: `${this.endpoint}/new`,
      method: 'POST',
      data: {
        siteDetails: stationDetailsRequest,
        historicalDataFilename: historicalDataFilename
      }
    }).then((httpData) => {
    });
  }

  getStations():ng.IPromise<IStation[]> {
    return this.$http<IImomoResponse<IStation>>({
      url: this.endpoint,
      method: 'GET'
    }).then((httpData) => {
      return httpData.data.resources;
    })
  }

  getStation({stationCode, stationId}:{
    stationCode?:string,
    stationId?:number
  }):ng.IPromise<IStation> {
    let promise:ng.IHttpPromise<IImomoResponse<IStation>>;
    if (stationCode) {
      promise = this.$http({
        url: this.endpoint,
        method: 'GET',
        params: {
          siteCode: stationCode,
          ready: false
        }
      });
    } else if (stationId) {
      promise = this.$http<IImomoResponse<IStation>>({
        url: `${this.endpoint}/${stationId}`,
        method: 'GET',
      });
    }
    return promise.then(httpData => {
      return httpData.data.resources[0];
    });
  }

  isStationCodeUnique(stationCode:string):ng.IPromise<void> {
    const deferred = this.$q.defer<void>();
    this.$http({
      url: this.endpoint,
      method: 'GET',
      params: {
        siteCode: stationCode,
        ready: false
      }
    }).then(() => {
      deferred.reject();
    }).catch(() => {
      deferred.resolve();
    });
    return deferred.promise;
  }

  getStationPrecipitationNorm(stationId:number):ng.IPromise<IPrecipitationNorm> {
    return this.$http<IImomoResponse<IPrecipitationNorm>>({
      url: `${this.endpoint}/${stationId}/precipitation_norm`,
      method: 'GET'
    }).then(httpData => {
      return httpData.data.resources[0];
    });
  }

  getStationHistoricPrecipitationDataUrl(stationId:number):ng.IPromise<string> {
    return this.$http<IImomoResponse<{url:string}>>({
      url: `${this.endpoint}/${stationId}/average_historic_precipitation`,
      method: 'GET'
    }).then(httpData => {
      return httpData.data.resources[0].url;
    });
  }

  uploadHistoricPrecipitationData(stationId:number, filename:string):angular.IPromise<void> {
    return this.$http({
      url: `${this.endpoint}/${stationId}/average_historic_precipitation`,
      method: 'POST',
      data: {
        filename: filename
      }
    }).then((httpData) => {
    });
  }

  getStationTemperatureNorm(stationId:number):ng.IPromise<ITemperatureNorm> {
    return this.$http<IImomoResponse<ITemperatureNorm>>({
      url: `${this.endpoint}/${stationId}/temperature_norm`,
      method: 'GET'
    }).then(httpData => {
      return httpData.data.resources[0];
    });
  }

  getStationHistoricTemperatureDataUrl(stationId:number):ng.IPromise<string> {
    return this.$http<IImomoResponse<{url:string}>>({
      url: `${this.endpoint}/${stationId}/average_historic_temperature`,
      method: 'GET'
    }).then(httpData => {
      return httpData.data.resources[0].url;
    });
  }

  uploadHistoricTemperatureData(stationId:number, filename:string):angular.IPromise<void> {
    return this.$http({
      url: `${this.endpoint}/${stationId}/average_historic_temperature`,
      method: 'POST',
      data: {
        filename: filename
      }
    }).then((httpData) => {
    });
  }

  validatePrecipitationData(filename:string) {
    return this.$http({
      url: `${this.endpoint}/average_historic_precipitation`,
      method: 'GET',
      params: {
        validate: true,
        filename: filename
      }
    }).then(() => {
    });
  }

  validateTemperatureData(filename:string) {
    return this.$http({
      url: `${this.endpoint}/average_historic_temperature`,
      method: 'GET',
      params: {
        validate: true,
        filename: filename
      }
    }).then(() => {
    });
  }

  updateStation(stationId:number,
                stationUpdateDetailsRequest:IStationDetailsRequest) {
    return this.$http({
      url: `${this.endpoint}/${stationId}`,
      method: 'PUT',
      data: stationUpdateDetailsRequest
    }).then(() => {
    });
  }
}



/** WEBPACK FOOTER **
 ** ./app/api/meteostation-api.service.ts
 **/